import styles from "./button.module.css";
import {MouseEventHandler} from "react";

type ButtonProps = {
    cls?: string;
    style?: React.CSSProperties;
    type?: "submit" | "reset" | "button";
    children?: React.ReactNode;
    block?: boolean;
    color?: string;
    disabled?: boolean;
    size?: "small" | "medium" | "large";
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | Promise<void>;
    [key: string]: any;
}

const Button: React.FC<ButtonProps> = (props) => {
    const {
        cls,
        style,
        color,
        type = "button",
        disabled,
        children,
        block = false,
        size,
    } = props;

    const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        if (disabled) return;
        if (!props.onClick) return;
        props.onClick(e);
    }

    return (
        <button
            style={{
                backgroundColor: color,
                ...style,
                borderRadius: style?.borderRadius ? style.borderRadius : style?.height
            }}
            className={`${block ? styles.bock : ''} ${size ? styles[size] : ''} ${cls}`}
            type={type}
            disabled={disabled}
            onClick={handleClick}
        >
            {children}
        </button>
    )
}

export default Button;
